import { render, staticRenderFns } from "./email.vue?vue&type=template&id=5213435a&scoped=true"
import script from "./email.vue?vue&type=script&lang=js"
export * from "./email.vue?vue&type=script&lang=js"
import style0 from "./email.vue?vue&type=style&index=0&id=5213435a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5213435a",
  null
  
)

export default component.exports